import { Link, useLocation, useNavigate } from "react-router-dom";
import { LayoutDashboard, Route, Plus, FileText, Menu, Lock } from "lucide-react";
import { useCanCreateTrip } from "@/hooks/useCanCreateTrip";
import { toast } from "sonner";

const mobileNavItems = [
  { title: "Dashboard", url: "/dashboard", icon: LayoutDashboard },
  { title: "Matkat", url: "/trips", icon: Route },
  { title: "Lisää", url: "/trips/new", icon: Plus, isAction: true },
  { title: "Raportit", url: "/reports", icon: FileText },
  { title: "Valikko", url: "/more", icon: Menu },
];

export default function MobileNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const { canCreate } = useCanCreateTrip();

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 border-t border-border bg-card/95 backdrop-blur-lg md:hidden">
      <div className="flex items-center justify-around px-2 py-1">
        {mobileNavItems.map((item) => {
          const isActive = item.url === "/dashboard"
            ? location.pathname === "/dashboard"
            : location.pathname.startsWith(item.url);

          if (item.isAction) {
            const handleClick = (e: React.MouseEvent) => {
              if (!canCreate) {
                e.preventDefault();
                toast.error("Tilaus tai krediitit vaaditaan", {
                  description: "Osta tilaus tai krediittejä jatkaaksesi matkojen kirjaamista.",
                });
                navigate("/manage");
              }
            };

            return (
              <Link
                key={item.url}
                to={canCreate ? item.url : "/manage"}
                onClick={handleClick}
                className="flex flex-col items-center -mt-4"
              >
                <div className={`flex h-12 w-12 items-center justify-center rounded-2xl shadow-lg ${
                  canCreate
                    ? "bg-primary shadow-primary/30"
                    : "bg-muted shadow-muted/30"
                }`}>
                  {canCreate ? (
                    <item.icon className="h-5 w-5 text-primary-foreground" />
                  ) : (
                    <Lock className="h-5 w-5 text-muted-foreground" />
                  )}
                </div>
                <span className={`mt-1 text-[10px] font-medium ${canCreate ? "text-primary" : "text-muted-foreground"}`}>
                  {item.title}
                </span>
              </Link>
            );
          }

          return (
            <Link
              key={item.url}
              to={item.url}
              className={`flex flex-col items-center gap-0.5 py-2 px-3 ${
                isActive
                  ? "text-primary"
                  : "text-muted-foreground"
              }`}
            >
              <item.icon className="h-5 w-5" />
              <span className="text-[10px] font-medium">{item.title}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
